var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLedConfirmationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 59.063a27.562 27.562 0 110-55.125 27.562 27.562 0 010 55.124zm0 3.937a31.5 31.5 0 100-63 31.5 31.5 0 000 63z",
    fill: "#FFA700"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.692 22.782a.933.933 0 00.949.973h3.248c.544 0 .977-.445 1.047-.984.355-2.583 2.127-4.466 5.285-4.466 2.7 0 5.174 1.351 5.174 4.6 0 2.5-1.473 3.65-3.8 5.398-2.65 1.925-4.749 4.174-4.6 7.824l.013.854a.985.985 0 00.984.969h3.193a.984.984 0 00.985-.985v-.413c0-2.827 1.075-3.65 3.977-5.851 2.398-1.823 4.898-3.847 4.898-8.096 0-5.95-5.024-8.824-10.525-8.824-4.989 0-10.454 2.323-10.828 9.001zm6.13 22.692c0 2.099 1.674 3.65 3.977 3.65 2.398 0 4.048-1.551 4.048-3.65 0-2.173-1.654-3.701-4.052-3.701-2.3 0-3.973 1.528-3.973 3.701z",
    fill: "#FFA700"
  })));
}
export default SvgLedConfirmationIcon;